<script lang="ts">
  import { type Snippet } from 'svelte'
  import { CheckIcon } from '@lucide/svelte'

  type Props = {
    selected: boolean
    onclick: () => void
    children: Snippet
  }

  const { onclick, selected, children }: Props = $props()
</script>

<button
  class:selected
  {onclick}
>
  <span>{@render children()}</span>
  <CheckIcon />
</button>

<style lang="scss">
  button {
    align-items: stretch;
    background-color: var(--select-background);
    border: none;
    color: var(--select-foreground);
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    outline: none;
    padding-left: 0.5rem;
    padding: 0.25rem;
    text-align: start;

    &:focus-visible {
      outline: 1px solid var(--stroke);
      outline-offset: 2px;
      z-index: 1;
    }

    &.selected {
      span {
        font-weight: 500;
      }

      :global(svg) {
        display: block;
      }
    }

    &:first-child {
      border-top-left-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
    }

    &:last-child {
      border-bottom-left-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }

    &:not(:first-child) {
      border-top: 1px solid var(--select-separator-background);
    }

    span {
      line-height: 150%;
      font-size: 0.75rem;
      color: var(--select-foreground);
    }

    :global(svg) {
      display: none;
      height: 0.75rem;
      width: 0.75rem;
      padding: 0.125rem;
      stroke: var(--select-foreground);
    }
  }
</style>
